import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const GovernmentProcurementCase = () => import('@/views/GovernmentProcurementCase')
const Production = () => import('@/views/Production')
const FourNav = () => import('@/views/FourNav')
const FiveNav = () => import('@/views/FiveNav')
const ReportList = () => import('@/components/report_list/index.vue')
const ArticleDetails = () => import('@/components/report_list/articleDetails.vue')
const Contact = () => import('@/components/contact/contact.vue')
const Realize = () => import('@/components/realize/index.vue')
const Service = () => import('@/views/Service')
const productService = () => import('@/components/product_service/index.vue')
const ServiceDetails = () => import('@/components/product_service/details.vue')
const ServicePubdetails = () => import('@/components/product_service/pubdetails.vue')
const ServiceTrain = () => import('@/components/product_service/train.vue')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/GovernmentProcurementCase',
    component:GovernmentProcurementCase
  },
  {
    path:'/production',
    component:Production,
    children:[
      {
        path:'contact',
        component:Contact,
        scrollBehavior(to, from, savedPosition) {
          if (to.hash) {
            return {
              selector: to.hash,
              behavior: 'smooth' // 可选，添加平滑滚动效果
            }
          }
          return { x: 0, y: 500 } // 默认滚动到顶部
        },
      },
    ]
  },
  {
    path:'/fournav',
    component:FourNav,
    children:[
      {
        path:'1',
        component:ReportList
      },
      {
        path:'ArticleDetails/:id?',
        component:ArticleDetails
      },
    ]
  },
  {
    path:'/fivenav',
    component:FiveNav,
    children:[
      {
        path:'1',
        component:Realize
      },
    ]
  },
  {
    path:'/product',
    component:Service,
    children:[
      {
        path:'service',
        component:productService,
      },
      {
        path:'details/:id?',
        name: 'ServiceDetails',
        component:ServiceDetails,
      },
      {
        path:'detailInfo/:id?',
        name: 'ServicePubdetails',
        component:ServicePubdetails,
      },
      {
        path:'train/:id?',
        name: 'ServiceTrain',
        component:ServiceTrain,
      },
    ],
  },
  
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router